import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AuthContextProvider } from "./context/auth";
import { ProfileContextProvider } from "./context/profile";
import { ToasterProvider } from "./context/toaster";
import "intersection-observer";
import { SearchContextProvider } from "./context/search";
import ErrorBoundary from "./components/Atomics/ErrorBooundary";
import ErrorPage from "./components/Atomics/ErrorBooundary/ErrorPage";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ErrorPage />}>
      <ToasterProvider>
        <AuthContextProvider>
          <ProfileContextProvider>
            <SearchContextProvider>
              <App />
            </SearchContextProvider>
          </ProfileContextProvider>
        </AuthContextProvider>
      </ToasterProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register the service worker
serviceWorkerRegistration.register();

// Optional: Measure performance
reportWebVitals();
